<template lang="pug">
vm-prompt( vm-size="medium" @vm-cancel="close" @vm-accept="OnReceive" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" vm-title='Confirmar')
  vm-row(class="section-receptions" vm-w="12")
    vm-col(class="section-receptions__text" vm-w=6 vm-type="flex")
      span {{ $t('strings.purchase_order') }}: {{ form.folio }}
    vm-col(class="section-receptions__text" vm-type="flex" vm-w=6)
      vm-input(autofocus :placeholder='$t("purchase_orders.number_placeholder")' :danger="$v.form.invoice_number.$invalid && $v.form.invoice_number.$model" :danger-text="$t('validation.required', { attribute: $t('purchase_orders.number') })" v-model="form.invoice_number" :label='$t("purchase_orders.number")')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12 class="section-receptions__details")
        vm-col(vm-type="flex" vm-align="center" vm-lg=12 vm-sm=12)
          .section-custom__icon
            vm-icon(icon="search-outline" size="1rem")
          span {{ $t('quotations.details_data') }}
        vm-row.table_products(vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=12)
            vm-table(max-height="350px" max-items="10" pagination :data="details" )
              template(slot="thead")
                vm-th(:key="index" v-for="(column, index) in columns") {{ $t('purchase_orders.' + column) }}
              template(slot-scope="{data}")
                vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                  vm-td(:data="data[indextr][column]" :key="index" v-for="(column, index) in columns")
                    slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                    slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                    slot(v-if="column == 'supply'")  {{ data[indextr][column]['sku'] }}
                    slot(v-if="column != 'status' && column != 'remaining' && column != 'supply' && column != 'created_at' && column != 'name' && column != 'name' && column != 'role' && column != 'total' && column != 'unit_price'") {{data[indextr][column]}}
            transition(name="enter")
              .total-products(v-if="details > 0") Total de productos: {{ hasReceptions }}
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('WarehouseReceptions')

export default {
  name: 'ModalWarehouseReceptions',
  mixins: [ModalMixin1],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    details: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    columns: ['id', 'supply', 'supply_unit', 'supply_pending_quantity', 'received', 'for_recieving']
  }),
  validations () {
    return {
      form: {
        invoice_number: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'purchaseOrders']),
    hasReceptions () {
      return this.details ? this.details.reduce((acc, crr) => { return +acc + +crr.for_recieving }, 0) : 0
    }
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'saveRecption',
      'setModalVisible'
    ]),
    OnReceive () {
      this.saveRecption({
        purchase_order_id: this.form.id,
        invoice_number: this.form.invoice_number,
        product_amount: this.details.length,
        details:
          this.details.map((detail) => ({
            ...detail,
            supply_amount: detail.for_recieving,
            supply_pending_quantity: detail.supply_pending_quantity - detail.for_recieving
          }))
      })
    }
  }
}
</script>
<style lang="scss">
.section-receptions {
  &__text {
    .vm-con-input-label {
      width: 100%;
    }
  }
}
</style>
